import { WebProtocolWarningMessage } from 'src/components/WebProtocolWarningMessage';
import { withAlert } from 'src/components/withAlert';
import { WebProtocol } from 'src/constants/web';
import { getProtocols } from 'src/utils/web/getProtocols';
import { isUrlLocalhost } from 'src/utils/web/isUrlLocalhost';
import { isWebProtocol } from 'src/utils/web/isWebProtocol';

export const warnWebProtocolInconsistencies = async (endpoint: string) => {
  const { appProtocol, endpointProtocol } = getProtocols(endpoint);
  const isEndpointLocalhost = isUrlLocalhost(endpoint);

  if (
    !endpointProtocol ||
    !isWebProtocol(appProtocol) ||
    !isWebProtocol(endpointProtocol) ||
    (appProtocol === endpointProtocol &&
      !(appProtocol === WebProtocol.HTTP && isEndpointLocalhost))
  ) {
    return;
  }

  withAlert({
    className: 'sd-dialog-web-protocol',
    message: WebProtocolWarningMessage({
      appProtocol,
      endpointProtocol,
      isEndpointLocalhost,
    }),
  });
};
